import classNames from "classnames";

export interface SidebarProps {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const Sidebar = ({
  children,
  className = "",
  ...rest
}: SidebarProps) => (
  <aside
    className={classNames(
      "bg-primary border-primary grid-in-sidebar size-full overflow-y-auto border-r",
      className,
    )}
    data-testid="side-menu-bar"
    {...rest}
  >
    {children}
  </aside>
);
